<div class="add-edit-user">
  <h2 class="headline">{{'USER_LIST.MODAL.ADD_USER' | translate}}</h2>
  <form
    [formGroup]="form"
    (ngSubmit)="sendForm()"
    class="add-edit-user__body">

    <div class="add-edit-user__body-inputs">
      <div class="scroll-block">
        <div
          [class.error]="form.get('fullNameFormControl')?.invalid && form.get('fullNameFormControl')?.touched"
          class="input-block">
          <input
            formControlName="fullNameFormControl"
            id="fullName"
            class="input"
            type="text"
            placeholder=" ">
          <label
            for="fullName"
            class="placeholder">
            {{'USER_LIST.MODAL.FUL_NAME' | translate}}
          </label>
          <ng-container *ngIf="form.get('fullNameFormControl')?.invalid && form.get('fullNameFormControl')?.touched">
          <span
            *ngIf="fullNameRequireError"
            class="input-block__error">
            {{'USER_LIST.MODAL.FULL_NAME_REQUIRED' | translate}}
          </span>
            <span
              *ngIf="!fullNameRequireError && fullNameFormatError"
              class="input-block__error">
            {{'USER_LIST.MODAL.FULL_NAME_FORMAT_ERROR' | translate}}
          </span>
          </ng-container>
        </div>

        <div class="line">
          <div
            [class.error]="form.get('phoneFormControl')?.invalid && form.get('phoneFormControl')?.touched"
            class="input-block">
            <input
              formControlName="phoneFormControl"
              id="phone"
              class="input"
              type="text"
              prefix="+7 "
              mask="000 000 00 00"
              placeholder=" ">
            <label
              for="phone"
              class="placeholder">
              {{'USER_LIST.MODAL.PHONE' | translate}}
            </label>
            <ng-container *ngIf="form.get('phoneFormControl')?.invalid && form.get('phoneFormControl')?.touched">
            <span
              *ngIf="phoneFormatError"
              class="input-block__error">
              {{'USER_LIST.MODAL.PHONE_REQUIRED' | translate}}
            </span>
            </ng-container>
          </div>

          <div
            [class.error]="form.get('emailFormControl')?.invalid && form.get('emailFormControl')?.touched"
            class="input-block">
            <input
              formControlName="emailFormControl"
              id="email"
              class="input"
              type="text"
              placeholder=" ">
            <label
              for="email"
              class="placeholder">
              {{'USER_LIST.MODAL.E_MAIL' | translate}}
            </label>
            <ng-container *ngIf="form.get('emailFormControl')?.invalid && form.get('emailFormControl')?.touched">
            <span
              *ngIf="emailFormatError"
              class="input-block__error">
              {{'USER_LIST.MODAL.EMAIL_REQUIRED' | translate}}
            </span>
              <span
                *ngIf="emailRequireFormatError"
                class="input-block__error">
            {{'USER_LIST.MODAL.EMAIL_FORMAT_ERROR' | translate}}
            </span>
            </ng-container>
          </div>
        </div>

        <div class="line">
          <div
            [class.error]="form.get('statusFormControl')?.invalid && form.get('statusFormControl')?.touched"
            [class.active]="isOpenStatusSelect"
            class="input-block select">
            <input
              formControlName="statusFormControl"
              [readonly]="true"
              (click)="openStatusSelect($event)"
              id="status"
              class="input"
              type="text"
              placeholder=" ">
            <label
              for="status"
              class="placeholder">
              {{'USER_LIST.MODAL.STATUS' | translate}}
            </label>
            <ul class="select__list">
              <li
                *ngFor="let item of statusList"
                (click)="setStatus(item)"
                class="select__list-item">{{'USER_LIST.MODAL.' + item.name | translate}}</li>
            </ul>
            <ng-container
              *ngIf="form.get('statusFormControl')?.invalid && form.get('statusFormControl')?.touched">
            <span
              *ngIf="statusFormatError"
              class="input-block__error">
              {{'USER_LIST.MODAL.STATUS_REQUIRED' | translate}}
            </span>
            </ng-container>
          </div>
          <div
            [class.error]="form.get('roleFormControl')?.invalid && form.get('roleFormControl')?.touched"
            [class.active]="isOpenRoleSelect"
            class="input-block select">
            <input
              formControlName="roleFormControl"
              [readonly]="true"
              (click)="openRoleSelect($event)"
              id="role"
              class="input"
              type="text"
              placeholder=" ">
            <label
              for="role"
              class="placeholder">
              {{'USER_LIST.MODAL.ROLE' | translate}}
            </label>
            <ul class="select__list">
              <li
                *ngFor="let item of roleList"
                (click)="setRole(item)"
                class="select__list-item">{{item.name}}</li>
            </ul>
            <ng-container
              *ngIf="form.get('roleFormControl')?.invalid && form.get('roleFormControl')?.touched">
            <span
              *ngIf="roleFormatError"
              class="input-block__error">
              {{'USER_LIST.MODAL.ROLE_REQUIRED' | translate}}
            </span>
            </ng-container>
          </div>
        </div>

        <label class="checkbox">
          <input
            [checked]="twoFactor"
            (change)="twoFactor = !twoFactor"
            type="checkbox"
            class="checkbox__input checkboxItem">
          <span class="checkbox__icon"></span>
          <span
            class="checkbox__name">
          {{'USER_LIST.MODAL.2FA' | translate}}
        </span>
        </label>
      </div>
      <div class="btn-block">
        <button
          [disabled]="form.invalid || isSending"
          type="submit"
          class="btn btn-accent btn-send">
          {{'USER_LIST.MODAL.ADD_BUTTON' | translate}}
        </button>
        <button
          (click)="modalService.closeModal()"
          type="button"
          class="btn btn-light btn-send">
          {{'USER_LIST.MODAL.CANCEL' | translate}}
        </button>
      </div>
    </div>
  </form>
</div>
